import React, {useState, Fragment, useCallback, Suspense} from 'react';
import { Card, CardBody, CardHeader, Form, FormGroup, Input  } from 'reactstrap';
import { Breadcrumbs, Btn, H4 } from '../../../../AbstractElements';
import Loader from '../../../../Layout/Loader'
import DataTable from 'react-data-table-component';
import { doctortabledata, tableColumns } from '../../../../Data/Doctor';
import { useNavigate } from 'react-router';
import { Media } from 'reactstrap';
import { Navigator } from '../../../../Data/Table/Defaultdata';
const ManageBranch = () =>{

  const navigate = useNavigate()

  const [searchKeyword, setSearchKeyword] = useState('');
  const handleSearchKeyword = (keyword) => {
      setSearchKeyword(keyword);
      // searchMember(keyword);
  };

  const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelet, setToggleDelet] = useState(false);
    

    const doctortabledata = [
        {
            id: 1,
            name: <Media body className="align-self-center">
                    <div className="f-w-700 font-success">Branch Name</div>
                </Media>,
            admin:  <Media body className="align-self-center">
            <div className="f-w-700 font-info">Admin Name</div></Media>,
            location: 'City',
            branchcontact: "8998989898",
            adminnumber: <span className="f-w-700 font-warning"> 9988776656</span>,
            action: <span>
            
            <Navigator to={`${process.env.PUBLIC_URL}/settings/managebranchform/:layout`}/>
          </span>
    
        },
    ];

    const [data, setData] = useState(doctortabledata);
    
     const tableColumns = [
        {
            name: '#',
            selector: row => row['id'],
            sortable: true,
            center: false,
        },
        {
            name: 'Branch Name',
            selector: row => row['name'],
            sortable: true,
            center: false,
        },
        {
            name: 'Admin Name',
            selector: row => row['admin'],
            sortable: true,
            center: true,
        },
        {
          name: 'Location',
          selector: row => `${row.location}`,
          sortable: true,
          center: true,
      },
        {
          name: 'Branch Contact',
          selector: row => `${row.branchcontact}`,
          sortable: true,
          center: true,
      },
        {
            name: 'Admin Number',
            selector: row => row['adminnumber'],
            sortable: true,
            center: true,
        },
        
        {
            name: 'Action',
            selector: row => row['action'],
            sortable: false,
            center: true,
        },
    ];

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    const handleDelete = () => {
        if (window.confirm(`Are you sure you want to delete:\r ${selectedRows.map(r => r.title)}?`)) {
            setToggleDelet(!toggleDelet);

            setData(data.filter((item) => selectedRows.filter((elem) => elem.id === item.id).length > 0 ? false : true));
            setSelectedRows('');
        }
    };
  return (
    <Suspense fallback={<Loader/>}>
    <Card>
       <Breadcrumbs mainTitle='Branch' parent='Dashboard' title='manage-branch' />
      <CardHeader className='card-no-border'>
        <div className='header-top'>
          <Fragment>
  <div className="search">
    <Form className="theme-form">
      <FormGroup className="form-group">
        <div className="input-group">
          <Input
            className="form-control"
            type="text"
            placeholder="search"
            defaultValue={searchKeyword}
            onChange={(e) => handleSearchKeyword(e.target.value)}
          />
          <div className="input-group-append">
            <span className="input-group-text">
              <i className="fa fa-search"></i>
            </span>
          </div>
        </div>
      </FormGroup>
    </Form>
  </div>
</Fragment>
          <div className='card-header-right-icon'>
            {/* <DropdownCommon dropdownMain={{ className: 'icon-dropdown', direction: 'start' }} options={DailyDropdown} iconName='icon-more-alt' btn={{ tag: 'span' }} /> */}
            <div className='card-header-right-icon'>
            <Btn attrBtn={{ color: 'light-primary', className: 'btn badge-light-primary', onClick: ()=> navigate(`${process.env.PUBLIC_URL}/settings/managebranchform/:layout`)}}>+ Add Branch</Btn>
          </div>
          </div>
        </div>
      </CardHeader>
      <CardBody className='pt-0 campaign-table'>
        <div className='recent-table table-responsive currency-table'>
        <Fragment>
        {(selectedRows.length !== 0) &&
                <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                    <H4 attrH4={{ className: 'text-muted m-0' }}>Delet Selected Data..!</H4>
                    <Btn attrBtn={{ color: 'danger', onClick: () => handleDelete() }}>Delete</Btn>
                </div>
            }
        <DataTable
                data={data}
                columns={tableColumns}
                striped={true}
                center={true}
                pagination
                selectableRows
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleDelet}
            />
            </Fragment>
        </div>
      </CardBody>
    </Card>
    </Suspense>
  );
}

export default ManageBranch